import { If, Icon } from 'cdui-js';

import { currencySpriteName } from '../../assets/currencyFlags';
import { ensureAsyncIcons } from '../../lib/ensure-async-icons';

void ensureAsyncIcons();

export type CurrencyFlagProps = {
  code: string;
  class?: string;
};

/** 三币种圆旗（async-icon / Icon，勿再用 assets URL） */
export const CurrencyFlag = (props: CurrencyFlagProps) => {
  // 须在渲染路径读 props.code，勿缓存 sprite 名，否则换币种图标不更新
  const name = () => currencySpriteName(props.code);
  return (
    <If when={!!name()}>
      <Icon
        name={name()}
        class={props.class ?? 'icon-s-S'}
        style={{ stroke: 'none', 'border-radius': '50%', overflow: 'hidden' }}
      />
    </If>
  );
};
